<div
  [attr.id]="module.slug || null"
  [attr.data-ancnav]="module.slug || null"
  class="content-module list-steps-module"
  [attr.data-is-slider]="module.isSlider"
  [attr.data-parent-subtype]="parentModule.subtype"
>

  <div class="steps-slider-wrapper" *ngIf="module.isSlider">
    <div class="steps-slider__top">
      <h4 class="steps-slider__title subtitle--one">{{'Common.Library.Modules.step_by_step'|translate}}</h4>
      <div class="slider-arrows slider-arrows--list-steps">
        <div class="icon icon-arrow icon-arrow--move-left slider-arrow slider-arrow--prev" [id]="'slider-arrow-prev--list-steps-' + module.slug"></div>
        <div class="icon icon-arrow icon-arrow--move-right slider-arrow slider-arrow--next" [id]="'slider-arrow-next--list-steps-' + module.slug"></div>
      </div>
    </div>
    <div class="steps-slider__bottom">
      <app-slider
        [module]="module"
        [additionalConfig]="{
          navigation: {
            prevEl: '#slider-arrow-prev--list-steps-' + module.slug,
            nextEl: '#slider-arrow-next--list-steps-' + module.slug
          }
        }"
      >
        <div class="step-wrapper swiper-slide" *ngFor="let step of module.steps; let i = index">
          <div class="step__index">{{ i + 1 }}</div>
          <div class="step__inner">
            <div class="step__top" *ngIf="step.text">
              <app-wysiwyg-content [content]="step.text"></app-wysiwyg-content>
            </div>
            <div class="step__bottom" *ngIf="step.image">
              <img [src]="step.image.url" [attr.alt]="step.image.alt || null" class="step__image">
            </div>
          </div>
        </div>
      </app-slider>
    </div>
  </div>

  <div class="steps-wrapper" *ngIf="!module.isSlider">
    <div class="step-wrapper" *ngFor="let step of module.steps; let i = index">
      <div class="step__index">{{ i + 1 }}</div>
      <div class="step__inner">
        <div class="step__top" *ngIf="step.text">
          <app-wysiwyg-content [content]="step.text"></app-wysiwyg-content>
        </div>
        <div class="step__bottom" *ngIf="step.image">
          <img [src]="step.image.url" [attr.alt]="step.image.alt || null" class="step__image">
        </div>
      </div>
    </div>
  </div>

</div>
